import React, { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import PolicyAcceptanceModal from './PolicyAcceptanceModal';
import AccountDisabled from './AccountDisabled';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, policiesAccepted, acceptPolicies, accountBlocked } = useAuth();
  const location = useLocation();
  const [isAcceptingPolicies, setIsAcceptingPolicies] = useState(false);

  // Free-tier access disabled — wall off the authenticated app (public routes,
  // which are not wrapped in ProtectedRoute, stay reachable).
  if (accountBlocked) {
    return <AccountDisabled />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  if (!policiesAccepted) {
    const handleAcceptPolicies = async () => {
      setIsAcceptingPolicies(true);
      try {
        await acceptPolicies();
      } finally {
        setIsAcceptingPolicies(false);
      }
    };

    return <PolicyAcceptanceModal onAccept={handleAcceptPolicies} isLoading={isAcceptingPolicies} />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
